










































































import mixins from 'vue-typed-mixins';
import { ReportNode, QuestionData } from '@/utils/ReportUtils';
import { Question } from '@/utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },
  },

  computed: {
    answer(): any {
      return this.value.data?.participation?.answer || {};
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },
  },

  methods: {
    handleChange() {
      this.$emit('dirty');
      if (this.value.data.participation) {
        let completeness = 0;

        if (
          this.answer.firstname !== undefined &&
          this.answer.firstname?.length > 0
        ) {
          completeness++;
        }

        if (
          this.answer.lastname !== undefined &&
          this.answer.lastname?.length > 0
        ) {
          completeness++;
        }

        this.value.data.participation.completeness = completeness / 2;
      }
    },
  },
});
